import { CompanyState, ProfileState } from '../store.states';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { memberAdapter } from './company.reducer';
import { MemberType } from '../../models/company.model';
import { selectProfileData } from '../profile/profile.selector';

export const selectCompanyState =
  createFeatureSelector<CompanyState>('company');

export const selectCompanyData = createSelector(
  selectCompanyState,
  (state: CompanyState) => ({
    ...state,
  })
);
export const selectCreateCompany = createSelector(
  selectCompanyState,
  (state: CompanyState) => ({
    ...state,
  })
);
export const selectCompanyMembers = createSelector(
  selectCompanyData,
  (state: CompanyState) => state.members
);

export const {
  selectAll: selectAllMembers,
  selectEntities: selectMemberEntities,
  selectIds: selectMemberIds,
  selectTotal: selectTotalMembers,
} = memberAdapter.getSelectors(selectCompanyMembers);

export const selectAllCompanyMembersWithSelfFirst = createSelector(
  selectAllMembers,
  selectProfileData,
  (members: MemberType[], profile: ProfileState) =>
    members.slice().sort((a, b) => {
        if (profile.id === a.userId) {
            return -1;
        } else if (profile.id === b.userId) {
            return 1;
        }
        return 0;
    })
);
